import { Formik } from "formik";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Col, Form as BTSForm, InputGroup, Row } from "react-bootstrap";
import { useSessionStore } from "../../../../Stores/SessionStore";
import BusyIndicator from "../../../Core/BusyIndicator";
import Address from "../../../Core/Customer/Address";
import Details from "../../../Core/Customer/Details";
import PageTitle from "../../../Core/PageTitle";
import ChangeEmailModal from "./Modals/ChangeEmailModal";
import ChangeNumberModal from "./Modals/ChangeNumberModal";
import ChangePinModal from "./Modals/ChangePinModal";
import DeleteAccountModal from "./Modals/DeleteAccountModal";
import { customerHasOwnPin } from "../../customerPinAuth";

const UserProfile = observer(function UserProfile() {
	const store = useSessionStore();
	const [showChangeEmail, setShowChangeEmail] = useState(false);
	const [showChangeNumber, setShowChangeNumber] = useState(false);
	const [showChangePin, setShowChangePin] = useState(false);
	const [showDeleteAccount, setShowDeleteAccount] = useState(false);

	const customer = store.CustomerDetails?.Customer;
	const hasPin = customerHasOwnPin(customer);
	const pinLinkText = hasPin ? "Change PIN" : "Set PIN";
	const profileActionLinkClassName =
		"border-0 bg-transparent p-0 text-decoration-underline profile-action-link";

	return (
		<React.Fragment>
			<PageTitle text="Edit Your Profile" />
			{store.CustomerDetails && (
				<Formik enableReinitialize initialValues={{ ...store.CustomerDetails.Customer }} onSubmit={() => undefined}>
					{() => (
						<Row>
							<Col xs={12} md={12} xl={8} className="offset-0 offset-xl-2">
								<Details disabled touched={{}} errors={{}} />
								{store.CustomerDetails.Address && <Address address={store.CustomerDetails.Address} />}

								<div className="d-flex justify-content-between align-items-center mb-1">
									<label className="form-label mb-0">Email</label>
									<button style={{ textDecoration: "underline" }} type="button" className={`${profileActionLinkClassName} text-success`} onClick={() => setShowChangeEmail(true)}>
										Change Email
									</button>
								</div>
								<BTSForm.Control className="mb-3 bg-light" value={customer?.Email ?? ""} readOnly disabled />

								<div className="d-flex justify-content-between align-items-center mb-1">
									<label className="form-label mb-0">WhatsApp Number</label>
									<button style={{ textDecoration: "underline" }} type="button" className={`${profileActionLinkClassName} text-success`} onClick={() => setShowChangeNumber(true)}>
										Change Number
									</button>
								</div>
								<InputGroup className="mb-3">
									<InputGroup.Text>+27</InputGroup.Text>
									<BTSForm.Control className="bg-light" value={customer?.CellphoneNumber ?? ""} readOnly disabled />
								</InputGroup>

								<div className="d-flex justify-content-between align-items-center mb-3">
									<label className="form-label mb-0">PIN</label>
									<button style={{ textDecoration: "underline" }} type="button" className={`${profileActionLinkClassName} text-success`} onClick={() => setShowChangePin(true)}>
										{pinLinkText}
									</button>
								</div>

								<div className="text-center mt-4">
									<button
										type="button"
										style={{ textDecoration: "underline" }} 
										className={`${profileActionLinkClassName} fw-bold text-danger`}
										onClick={() => setShowDeleteAccount(true)}
									>
										Delete Account
									</button>
								</div>
							</Col>
						</Row>
					)}
				</Formik>
			)}
			<BusyIndicator show={store.CustomerDetails === null} />
			<ChangeEmailModal show={showChangeEmail} onClose={() => setShowChangeEmail(false)} />
			<ChangeNumberModal show={showChangeNumber} onClose={() => setShowChangeNumber(false)} />
			<ChangePinModal show={showChangePin} onClose={() => setShowChangePin(false)} />
			<DeleteAccountModal show={showDeleteAccount} onClose={() => setShowDeleteAccount(false)} />
		</React.Fragment>
	);
});

export default UserProfile;
